/*
 * fn: isRecEqual
 *
 * Determines if two recs are equivalent
 *
 */
import { type RecType } from '@/defs/rec'
import { parseCardId } from '@/utils/cardUtil'

export const isRecEqual = (rec1: RecType, rec2?: RecType) => {
  const { slug: rec1Slug } = parseCardId(rec1.cardId)
  const { slug: rec1PartnerSlug } = rec1.partnerRef ? parseCardId(rec1.partnerRef.cardId) : {}
  const { slug: rec2Slug } = rec2?.cardId ? parseCardId(rec2.cardId) : {}
  const { slug: rec2PartnerSlug } = rec2?.partnerRef ? parseCardId(rec2.partnerRef.cardId) : {}

  return rec1Slug === rec2Slug && rec1PartnerSlug === rec2PartnerSlug && rec1.role === rec2?.role
}
